// =============================================================================
// features/sales/campaigns/detail/components/DetailPagination.tsx —
// Paginação reutilizada pelas abas Carteira/Retornos. Mesmo padrão visual de
// CampaignsPagination.tsx (F35-S07, fora de `files_allowed` — não
// importado/editado, só o mesmo tratamento).
// =============================================================================

import * as React from 'react';

export interface DetailPaginationProps {
  offset: number;
  limit: number;
  total: number;
  onOffsetChange: (offset: number) => void;
  itemLabel: string;
}

const NAV_BUTTON_CLASS =
  'px-3 py-1.5 min-h-[44px] rounded-sm font-sans text-xs font-medium border border-border ' +
  'transition-all duration-fast hover:bg-surface-hover hover:border-border-strong ' +
  'disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline-none ' +
  'focus-visible:ring-2 focus-visible:ring-azul/20';

export function DetailPagination({
  offset,
  limit,
  total,
  onOffsetChange,
  itemLabel,
}: DetailPaginationProps): React.JSX.Element | null {
  const totalPages = Math.ceil(total / limit) || 1;
  if (totalPages <= 1) return null;

  const currentPage = Math.floor(offset / limit) + 1;

  return (
    <nav
      className="flex items-center justify-between gap-2 px-4 py-3 border-t border-border-subtle"
      aria-label={`Paginação de ${itemLabel}`}
    >
      <p className="font-sans text-xs text-ink-3">
        {offset + 1}–{Math.min(offset + limit, total)} de {total} {itemLabel}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={offset <= 0}
          onClick={() => onOffsetChange(Math.max(0, offset - limit))}
          className={NAV_BUTTON_CLASS}
          aria-label="Página anterior"
        >
          ← Anterior
        </button>
        <span className="font-sans text-xs text-ink-3 self-center">
          {currentPage} / {totalPages}
        </span>
        <button
          type="button"
          disabled={currentPage >= totalPages}
          onClick={() => onOffsetChange(offset + limit)}
          className={NAV_BUTTON_CLASS}
          aria-label="Próxima página"
        >
          Próxima →
        </button>
      </div>
    </nav>
  );
}
